import React, { useEffect, useState } from 'react'
import { AvField, AvForm } from "availity-reactstrap-validation";
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { useSelector } from 'react-redux';
import { parametrageActions } from './parametrageSlice';
import Nouislider from 'nouislider-react';
import 'nouislider/distribute/nouislider.css';
import "react-rangeslider/lib/index.css";
const initForm = {
    categVeh: null,
    puissFiscale: null,
    percentYear1Di: 0,
    percentYear2Di: 0,
    percentYear3Di: 0,
    percentYear4Di: 0,
    percentYear5Di: 0,
    percentAfetrYear10Di: 0,
    percentYear1Es: 0,
    percentYear2Es: 0,
    percentYear3Es: 0,
    percentYear4Es: 0,
    percentYear5Es: 0,
    percentAfetrYear10Es: 0,
    pfMin:0,
    pfMax:0,
}

const ValeurVinalForm = ({ editingItem }) => {
    const { puissFis, categVH } = useSelector(state => state.data);

    const { t } = useTranslation('translation');
    const [form, setForm] = useState(initForm);

    const dispatch = useDispatch();

    useEffect(() => {
        if (editingItem) {
            setForm({ ...editingItem });
        }
    }, [editingItem]);

    const formik = useFormik({
        initialValues: { ...form },
        enableReinitialize: true,
        onSubmit: (values, { resetForm }) => {
            let payload = {
                data: values,
                onSuccess: () => {
                    dispatch(parametrageActions.listVvinale());
                }
            };

            if (values?.id > 0) {
                dispatch(parametrageActions.updateVvinale(payload));
            } else {
                dispatch(parametrageActions.createVvinale(payload));
            }
            resetForm()

        }
    });

    const handleChangeCategVH = ({ target }) => {
        formik.setFieldValue('categVeh', categVH.find(d => d.code === target.value)?.code);
    }


    useEffect(() => {
        let slider = document.getElementById("product-price-range");
        slider?.setAttribute("data-slider-color", "success");
    }, [])


    return (
        <React.Fragment>
            <AvForm className="needs-validation" onValidSubmit={formik.handleSubmit} >
                <Row className="mb-4">
                    <Col md="2">
                        <Label htmlFor="categorie" className="form-label">{t('parametrage.categorieV')}</Label>
                    </Col>
                    <Col md="4">
                        <select className="form-control" id='categorie' {...formik.getFieldProps('categVeh')} onChange={handleChangeCategVH}>
                            <option>Sélectionner...</option>
                            {
                                categVH.map((option, index) =>
                                    <option key={index} value={option.code}>
                                        {option.description}
                                    </option>
                                )}
                        </select>
                    </Col>

                </Row>
                <Row>
                    <Col md="2">
                        <Label htmlFor="puissance" className="form-label">{t('parametrage.puissanceFiscaleMin')}</Label>
                    </Col>
                    <Col md="4">
                        <AvField
                            {...formik.getFieldProps('pfMin')}
                            placeholder="0"
                            type="number"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="pfMin"
                        />
                    </Col>
                    <Col md="2">
                        <Label htmlFor="puissance" className="form-label">{t('parametrage.puissanceFiscaleMax')}</Label>
                    </Col>
                    <Col md="4">
                        <AvField
                            {...formik.getFieldProps('pfMax')}
                            placeholder="0"
                            type="number"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="pfMax"
                        />
                    </Col>
                </Row>
                <Row>
                    <span className="mb-2">{t('parametrage.percentage')}</span>
                </Row>
                <Row>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee1">{t('parametrage.annee1')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear1Di')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel1"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee2">{t('parametrage.annee2')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear2Di')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel2"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee3">{t('parametrage.annee3')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear3Di')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel3"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee4">{t('parametrage.annee4')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear4Di')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel4"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee5">{t('parametrage.annee5')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear5Di')}
                            placeholder='%'
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel5"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee6">{t('parametrage.annee6')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentAfetrYear10Di')}
                            placeholder='%'
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel6"
                        />
                    </Col>
                </Row>
                <Row>
                    <span className="mb-2">{t('parametrage.essencE')}</span>
                </Row>
                <Row>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee1">{t('parametrage.annee1')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear1Es')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel1"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee2">{t('parametrage.annee2')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear2Es')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel2"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee3">{t('parametrage.annee3')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear3Es')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel3"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee4">{t('parametrage.annee4')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear4Es')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel4"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee5">{t('parametrage.annee5')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear5Es')}
                            placeholder='%'
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel5"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee6">{t('parametrage.annee6')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentAfetrYear10Es')}
                            placeholder='%'
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel6"
                        />
                    </Col>
                </Row>
                <Row>
                    <span className="mb-2">{t('parametrage.hybrid')}</span>
                </Row>
                <Row>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee1">{t('parametrage.annee1')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear1Hy')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel1"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee2">{t('parametrage.annee2')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear2Hy')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel2"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee3">{t('parametrage.annee3')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear3Hy')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel3"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee4">{t('parametrage.annee4')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear4Hy')}
                            placeholder="%"
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel4"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee5">{t('parametrage.annee5')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentYear5Hy')}
                            placeholder='%'
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel5"
                        />
                    </Col>
                    <Col md="2">
                        <Label className="form-label" htmlFor="annee6">{t('parametrage.annee6')}</Label>
                        <AvField
                            {...formik.getFieldProps('percentAfetrYear10Hy')}
                            placeholder='%'
                            type="text"
                            errorMessage={t('message.required')}
                            className="form-control"
                            validate={{ required: { value: true } }}
                            id="diesel6"
                        />
                    </Col>
                </Row>
                <Col md="12" className="d-flex justify-content-end">
                    <Button color="primary" type="submit" size="sm">{t('actions.save')}</Button>
                    <Button color="danger" size="sm" type='reset' className="mx-2" onClick={() => setForm({ ...initForm })}>{t('actions.clear')}</Button>
                </Col>
            </AvForm>
        </React.Fragment>
    )
}

export default ValeurVinalForm